import {useEffect, useState} from 'react';
import Modal from '@stencil/hotels-modal-component';
import styled from 'styled-components';
import {Redirect} from 'react-router-dom';

const ModalContentContainer = styled.div(
  props => `
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`,
);

const CounterContainer = styled.div(
  props => `
  padding: ${props.theme.spacing.large} 0;
`,
);

const WhatHappenedModal: React.FC<{
  title: string;
  redirect?: {
    shouldRedirect: boolean;
    to: string;
    after?: number;
    displayText?: string;
  };
  children?: React.ReactNode;
  isMweb?: boolean;
}> = ({title, redirect = {}, children, isMweb = false}) => {
  const {shouldRedirect, to, after = 5, displayText} = redirect;

  const shouldDefinitelyRedirect = !!shouldRedirect && !!to;

  const [willRedirectAfter, setWillRedirectAfter] = useState(after);

  const redirectNow = willRedirectAfter === 0;

  useEffect(() => {
    if (!shouldDefinitelyRedirect) {
      return;
    }

    const timerId = setInterval(() => {
      setWillRedirectAfter(prev => prev - 1);
    }, 1000);

    return () => {
      if (timerId) {
        clearInterval(timerId);
      }
    };
  }, [shouldDefinitelyRedirect, after]);

  return (
    <Modal
      isOpen={true}
      modalStyles={{
        height: isMweb ? '13vh' : '40vh',
        width: isMweb ? '77vw' : '50vw',
      }}
      hideCloseButton
    >
      {shouldDefinitelyRedirect && redirectNow && <Redirect to={to} />}

      <ModalContentContainer>
        <h2>{title}</h2>

        {shouldDefinitelyRedirect && (
          <CounterContainer>
            Redirecting {displayText ? ` you to ${displayText}` : ''} after {willRedirectAfter}
          </CounterContainer>
        )}
      </ModalContentContainer>

      {children && {children}}
    </Modal>
  );
};

export default WhatHappenedModal;
